import { getPlanGroupByUserGroup } from './helpers/getPlanGroupByUserGroup'
import { UserTag } from './type'

import type { $Enums } from '@prisma/client'
import type { IBasicPlanGroupMapping } from './type'

import { PaymentPlatformPlatformName } from '@/contexts/SiteSpecificContext/types'


import { useMemo } from 'react';
export interface IUserPayPlatformGroup extends IBasicPlanGroupMapping {
  range: [number, number]
  platformName: Omit<$Enums.PaymentPlatformPlatformName, 'Paypal'>
}

/**
 * @description: 用户组与支付平台的映射关系
 */
export function useUserPayPlatformMapping() {
  // const hostKey = useHostKey()

  const userPayPlatformMapping: Record<UserTag, IUserPayPlatformGroup> =
    useMemo(() => {
      return {
        [UserTag.A]: {
          range: [101, 110],
          tag: UserTag.A,
          platformName: PaymentPlatformPlatformName.Stripe,
        },
        [UserTag.B]: {
          range: [111, 120],
          tag: UserTag.B,
          platformName: PaymentPlatformPlatformName.Stripe,
        },
        [UserTag.C]: {
          range: [121, 130],
          tag: UserTag.C,
          platformName: PaymentPlatformPlatformName.Stripe,
        },
        [UserTag.D]: {
          range: [131, 140],
          tag: UserTag.D,
          platformName: PaymentPlatformPlatformName.Payinsider,
        },
        [UserTag.E]: {
          range: [141, 150],
          tag: UserTag.E,
          platformName: PaymentPlatformPlatformName.Payinsider,
        },
        [UserTag.F]: {
          range: [151, 160],
          tag: UserTag.F,
          platformName: PaymentPlatformPlatformName.Payinsider,
        },
      }
    }, [])

  const getPayPlatformGroupByUserGroup = (userGroup: string) => {
    return getPlanGroupByUserGroup({
      userGroup,
      planGroupMapping: userPayPlatformMapping,
    })
  }

  return { userPayPlatformMapping, getPayPlatformGroupByUserGroup }
}
